define.alias("ember-truth-helpers/helpers/xor", "calendar/helpers/xor");